import PropTypes from "prop-types";
import React, { Component } from "react";
import { Trans } from "@lingui/macro";
import {
  Dialog,
  IconButton,
  Input,
  MenuItem,
  Select,
  withStyles
} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import { getWeekDays, timeSlot } from "../utils/constants";
import { translator } from "../utils/i18n";
import { connect } from "react-redux";
import { searchAvailableAppointmentList } from "../utils/scenario/scnr2-fetcher";
import SelectsDate from "./SelectsDate";
import { setMessage } from "../actions";
import CloseIcon from "@material-ui/icons/Close";

const styles = () => ({
  dialog: {
    borderRadius: "15px",
    maxWidth: "680px",
    width: "680px"
  }
});

class FormSearchList extends Component {
  state = {
    open: false,
    datedebutdispo: "",
    day: "",
    timeSlot: ""
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.setMessage(null);
  };

  getDate = e => {
    this.setState({ datedebutdispo: e });
  };

  buildSelect = (label, id, name, data) => {
    return (
      <div className="wrap-input">
        <Select
          name={name}
          input={<Input name={name} id={id} />}
          value={this.state[name]}
          onChange={this.onSelectChange}
          displayEmpty
          className="select"
        >
          <MenuItem value="">
            <Trans id={label} />
          </MenuItem>
          {data.map(item => {
            return (
              <MenuItem key={item.key || item.value} value={item.value}>
                {item.label}
              </MenuItem>
            );
          })}
        </Select>
      </div>
    );
  };

  onSelectChange = event => {
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    const { datedebutdispo, day, timeSlot } = this.state;
    this.props.searchAvailableAppointment({ datedebutdispo, day, timeSlot });
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <button
          onClick={this.handleClickOpen}
          className="custom-link no-style-btn"
        >
          <Trans id="W_STEP3_BAS_AFFINER_VOTRE_RECHERCHE" />
        </button>
        <Dialog
          aria-labelledby="search-dialog-title"
          open={this.state.open}
          onClose={this.handleClose}
          classes={{
            paper: classes.dialog
          }}
        >
          <IconButton
            className="close-dialog"
            aria-label="close"
            onClick={this.handleClose}
            style={{ color: "white", marginRight: "7px", padding: "0" }}
          >
            <CloseIcon />
          </IconButton>
          <DialogTitle className="head-dialog" id="search-dialog-title">
            <div className="title-dialog">
              <i className="material-icons">search</i>
              <span className="title-text">
                <Trans id="W_STEP3_BAS_AFFINER_VOTRE_RECHERCHE" />
              </span>
            </div>
          </DialogTitle>

          <div className="body-dialog">
            <form className="form-search" onSubmit={this.onSubmit}>
              <div className="line-form">
                {this.buildSelect(
                  "W_STEP3_POPUP_AFFINER_RECHERCHE_QUEL_JOUR",
                  "day",
                  "day",
                  getWeekDays()
                )}

                {this.buildSelect(
                  "W_CRENEAU_HORAIRE",
                  "timeSlot",
                  "timeSlot",
                  timeSlot()
                )}
              </div>
              <div className="line-date">
                <SelectsDate
                  label={translator()._(
                    "W_STEP3_AFFINER_VOTRE_RECHERCHE_A_PARTIR_DU"
                  )}
                  getDate={this.getDate}
                />
              </div>
              <div className="wrap-btns mt-30">
                <button className="btn-default" type="submit">
                  <Trans id="W_STEP3_AFFINER_VOTRE_RECHERCHE_BOUTON_RECHERCHER" />
                </button>
              </div>
            </form>
          </div>
        </Dialog>
      </div>
    );
  }
}

FormSearchList.propTypes = {
  classes: PropTypes.shape({
    dialog: PropTypes.any
  }),
  searchAvailableAppointment: PropTypes.func,
  setMessage: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  searchAvailableAppointment: dataForm =>
    dispatch(searchAvailableAppointmentList(dataForm)),
  setMessage: message => dispatch(setMessage(message))
});

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps
  )(FormSearchList)
);
